export const mockUsers = [
  {
    id: 1,
    name: 'John Doe',
    email: 'john@example.com',
    aiFeaturesUsed: ['AI Suggestion', 'Rewrite', 'Autofill'],
    lastActivity: '2 hours ago',
    resumesCreated: 3,
    resumesDownloaded: 2,
    journeyStage: 'paid',
    dropOffPoint: null,
    conversionValue: 49.98,
    valueScore: 85,
    tags: ['High Potential'],
    createdAt: '2024-01-15'
  },
  {
    id: 2,
    name: 'Jane Smith',
    email: 'jane@example.com',
    aiFeaturesUsed: ['AI Suggestion'],
    lastActivity: '1 day ago',
    resumesCreated: 1,
    resumesDownloaded: 0,
    journeyStage: 'paywall',
    dropOffPoint: 'paywall',
    conversionValue: 0,
    valueScore: 45,
    tags: ['Needs Follow-up'],
    createdAt: '2024-02-01'
  },
  {
    id: 3,
    name: 'Bob Johnson',
    email: 'bob@example.com',
    aiFeaturesUsed: ['AI Suggestion', 'Rewrite'],
    lastActivity: '3 hours ago',
    resumesCreated: 2,
    resumesDownloaded: 1,
    journeyStage: 'completed',
    dropOffPoint: null,
    conversionValue: 0,
    valueScore: 65,
    tags: ['Power User'],
    createdAt: '2024-02-15'
  },
  {
    id: 4,
    name: 'Alice Brown',
    email: 'alice@example.com',
    aiFeaturesUsed: ['AI Suggestion', 'Autofill'],
    lastActivity: '5 hours ago',
    resumesCreated: 4,
    resumesDownloaded: 3,
    journeyStage: 'paid',
    dropOffPoint: null,
    conversionValue: 99.96,
    valueScore: 90,
    tags: ['VIP', 'High Potential'],
    createdAt: '2024-01-20'
  },
  {
    id: 5,
    name: 'Charlie Wilson',
    email: 'charlie@example.com',
    aiFeaturesUsed: ['AI Suggestion'],
    lastActivity: '2 days ago',
    resumesCreated: 1,
    resumesDownloaded: 0,
    journeyStage: 'started',
    dropOffPoint: 'started',
    conversionValue: 0,
    valueScore: 30,
    tags: ['New User'],
    createdAt: '2024-02-20'
  }
]; 